import { graphql } from 'gql.tada';
export const LinkBlockFragment = graphql(
/* GraphQL */ `
    fragment LinkBlockFragment on LinkBlockRecord {
      ... on RecordInterface {
        id
        __typename
      }
      text
      file {
        url
        filename
      }
      target {
        ... on RecordInterface {
          id
          __typename
        }
        ... on CourseRecord {
          slug
          courseCode
        }
        ... on EditionRecord {
          course {
            ... on CourseRecord {
              slug
              courseCode
            }
          }
          productCode
        }
        ... on EventRecord {
          slug
        }
        ... on InstructorRecord {
          slug
        }
        ... on ExternalLinkRecord {
          url
        }
        ... on CoursesListingPageRecord {
          slug
        }
        ... on InstructorsListingPageRecord {
          slug
        }
        ... on FaqPageRecord {
          slug
        }
        ... on FormRecord {
          target
        }
        ... on TargetPageRecord {
          slug
        }
        ... on B2bServicePageRecord {
          slug: b2bServiceUrl
        }
        ... on PartnersPageRecord {
          _modelApiKey
        }
        ... on ContactPageRecord {
          _modelApiKey
        }
        ... on B2bPageRecord {
          _modelApiKey
        }
        ... on EventsListingPageRecord {
          _modelApiKey
          slug
        }
        ... on FinancingPageRecord {
          _modelApiKey
        }
        ... on HomePageRecord {
          _modelApiKey
        }
        ... on InstructorsPageRecord {
          _modelApiKey
        }
        ... on PartnersListingPageRecord {
          _modelApiKey
        }
        ... on SuccessfulPartnerCaseRecord {
          _modelApiKey
        }
      }
    }
  `, []);
//# sourceMappingURL=link-block.js.map